import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { PlacementEnvironmentDetailResponseData } from "../../types/placement-environment";

export const getData = async (
  id: string | undefined,
): Promise<PlacementEnvironmentDetailResponseData> => {
  const { data } = await api.get(`/placement-environments/${id}`);

  return data;
};

export const usePlacementEnvironment = (
  id: string | undefined,
): QueryObserverBaseResult<PlacementEnvironmentDetailResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.placementEnvironment(id),
    () => getData(id),
    { enabled: Boolean(id) },
  );
  return { data, ...props };
};
